import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsEncyclopediaSubcategory } from 'types/cms/collection-types'
import { stringify } from 'qs'

/**
 * Get the encyclopedia subcategories from the CMS for the given category slug
 *
 * @param {string} categorySlug
 * @param {Language} locale
 * @returns {Promise<CmsEncyclopediaCategory | undefined>}
 */
const getEncyclopediaSubcategoriesByCategorySlug = async (
  categorySlug: string,
  locale: Language = Language.DUTCH
): Promise<CmsEncyclopediaSubcategory[]> => {
  try {
    const query = stringify({
      filters: {
        category: {
          slug: {
            $eq: categorySlug
          }
        }
      },
      locale
    })

    const { data } = await axios.get<CMSApiResponseBody<CmsEncyclopediaSubcategory[]>>(
      `${process.env.CMS_API_URL}/encyclopedia-sub-categories?${query}`
    )

    return data.data ?? []
  } catch (_) {
    return []
  }
}

export default getEncyclopediaSubcategoriesByCategorySlug
